import {Star06Icon} from '../icon'
import {StyledNavigateAlert, StyledTextWrapper, StyledLeftSideWrapper, StyledSubText, StyledMainText} from './style'
import {useTranslation} from 'react-i18next'
import {useTheme} from 'styled-components'
import {ButtonLink} from '../button-link/ButtonLink'
import {formatLocaleDate} from '../../helpers/utils'

export const NavigateAlert = () => {
    const {t} = useTranslation()
    const theme = useTheme()

    return (
            <StyledNavigateAlert>
                <div className="container">
                        <StyledLeftSideWrapper>
                            <Star06Icon width={20} height={20} fill={theme.colors.darkYellow} />
                            <StyledTextWrapper>
                                <StyledMainText>{t('commons:navigate_banner_title')}</StyledMainText>
                                <StyledSubText>{t('commons:navigate_banner_subtext', {date: formatLocaleDate('2025-08-28', 'LL')})}</StyledSubText>
                            </StyledTextWrapper>
                        </StyledLeftSideWrapper>
                            <ButtonLink variant="secondary" size="sm" to={process.env.REACT_APP_NAVIGATE_URL} target="_blank">
                                {t('commons:navigate_banner_button')}
                            </ButtonLink>
                </div>
            </StyledNavigateAlert>
    )
}
